// pages/Dashboard.jsx
import Donate from "../components/donateComponents/Donate";
import HomeLayout from "../components/HomeLayout";

export default function DonatePage() {
  return (
    <HomeLayout>
      <Donate />
    </HomeLayout>
  );
}
